import config from "../config/config";
import axios from "axios";
import { getToken } from "../common";

export const getMyBidLogAPI = async (eventId, eventItemId) => {
    return await axios({
        method: "get",
        url: `${config.api.base_url}events/${eventId}/item/${eventItemId}/my-bid-log`,
        headers: {
            "Content-type": "application/json; charset=UTF-8",
            Authorization: getToken(),
        },
    });
};

export default getMyBidLogAPI;
